import useSWR from "swr";
import { simpleFetcher } from "../fetcher";

interface PreviewUrlResponse {
  previewUrl: string | null;
}

export function usePreviewUrl(documentArtifactId?: number) {
  const url = documentArtifactId
    ? `/api/v2/document-artifacts/${documentArtifactId}/preview-url`
    : null;

  const { data, error, isLoading } = useSWR<PreviewUrlResponse, Error>(
    url,
    simpleFetcher,
    { revalidateOnFocus: false, revalidateOnMount: true },
  );

  return {
    previewUrl: data?.previewUrl ?? null,
    error,
    isLoading,
  };
}
